'use client';

import { Toaster } from 'react-hot-toast';

/**
 * Conteneur react-hot-toast : doit être dans un composant client (App Router).
 * z-index élevé pour passer au-dessus des modales / headers admin.
 */
export function HotToaster() {
  return (
    <Toaster
      position="top-right"
      gutter={12}
      toastOptions={{
        duration: 4000,
        style: { zIndex: 2147483647 },
      }}
      containerStyle={{ zIndex: 2147483647 }}
    />
  );
}
